export enum Indicators {
  IRRIGATION = 'IRRIGATION',
  CHLOROPHYLL = 'CHLOROPHYLL',
}
